export default "__VITE_ASSET__BpnsibM0__"